import { Reveal } from "../site/Reveal";

export const TechTotal = () => (
  <section data-testid="growth-section" className="py-20 md:py-24 bg-white border-b border-slate-200">
    <div className="max-w-7xl mx-auto px-6">
      <Reveal>
        <div className="bg-slate-50 border border-slate-200 px-6 py-14 md:py-20 text-center">
          <span className="text-xs font-mono uppercase tracking-widest text-blue-600">Traiettoria di Crescita</span>
          <div
            data-testid="growth-total"
            className="mt-6 font-display text-4xl sm:text-6xl md:text-7xl font-extrabold tracking-[-0.03em] text-slate-950 leading-none"
          >
            Oltre <span className="text-blue-600">7,8 milioni</span> di euro
          </div>
          <p className="mt-6 text-sm md:text-base text-slate-600 max-w-2xl mx-auto leading-relaxed">
            Valore complessivo dei lavori realizzati da Saircos dal 2019 a oggi.
          </p>
          <p className="mt-3 text-[11px] font-mono uppercase tracking-widest text-slate-400">
            Stima aggiornata a ottobre 2026
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
